import { memo } from "react";

const Heart = memo((props: { className?: string }) => (
    <svg className={props.className} viewBox="0 0 161.3 160.7">
        <circle cx="80.6" cy="80.5" r="79.4" />
        <path d="M80.6,124.7L47.5,95.5c-4.7-4.6-7.3-10.7-7.3-17.2c0-13.2,10.8-24,24-24c6.2,0,12.1,2.4,16.4,6.5 c4.4-4.1,10.2-6.5,16.4-6.5c13.2,0,24,10.8,24,24c0,6.6-2.6,12.7-7.4,17.3L80.6,124.7z" />
    </svg>
));

export default Heart;
